import { render, staticRenderFns } from "./Propostas.vue?vue&type=template&id=22a317c6&"
import script from "./Propostas.vue?vue&type=script&lang=js&"
export * from "./Propostas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports